import { Store, PanelTop } from 'lucide-react';

export const FormatPill = ({ format, testid }) => {
  const vitrine = format === 'vitrine_deportee';
  const Icon = vitrine ? PanelTop : Store;
  return (
    <span data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide whitespace-nowrap ${vitrine ? 'bg-orange-100 text-orange-700 border-orange-300' : 'bg-slate-100 text-slate-700 border-slate-300'}`}>
      <Icon className="w-3 h-3" />{vitrine ? 'Vitrine déportée' : 'Corner'}
    </span>
  );
};
